function getEmbedUrl(url) {
        const regex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^& \n]+)/;
        const match = url.match(regex);
        const id = match ? match[1] : null;
        return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }

    async function loadGallery(retries = 3, videoDataPath) {
        const menu = document.getElementById('video-menu');
        const loadingMsg = document.getElementById('loading-msg');
        
        // Safety check: if menu doesn't exist yet, don't run
        if (!menu) return;
        try {
            const fetchUrl = videoDataPath.includes('?') 
                ? `${videoDataPath}&t=${new Date().getTime()}` 
                : `${videoDataPath}?t=${new Date().getTime()}`;

            const response = await fetch(fetchUrl);
            if (!response.ok) throw new Error("Connection failed");

            const data = await response.json();
            menu.innerHTML = ''; 

            const iframe = document.getElementById('video-frame');
            const titleDisp = document.getElementById('current-title');
            const descDisp = document.getElementById('current-desc');

            data.sections.forEach(section => {
                const sectionHeader = document.createElement('h3');
                sectionHeader.textContent = section.sectionTitle;
                menu.appendChild(sectionHeader);

                section.videos.forEach(video => {
                    const item = document.createElement('div');
                    item.className = 'video-item';
                    item.innerHTML = `<strong>${video.title}</strong><br><small>${video.description}</small>`;
                    
                    item.onclick = () => {
                        iframe.src = getEmbedUrl(video.link);
                        titleDisp.textContent = video.title;
                        descDisp.textContent = video.description;
                        document.querySelectorAll('.video-item').forEach(el => el.classList.remove('active'));
                        item.classList.add('active');
                    };
                    menu.appendChild(item);
                });
            });

        } catch (error) {
            if (retries > 0) {
                setTimeout(() => loadGallery(retries - 1, videoDataPath), 1500);
            } else {
                menu.innerHTML = '<div style="padding: 20px;"><p>ദയവായി പേജ് ഒന്ന് പുതുക്കുക (Refresh).</p></div>';
            }
        }
    }

function initVideoGallery() {
  const menu = document.getElementById('video-path');
  if (!menu) return;
  if (menu.dataset.vgInit === "1") return;

  menu.dataset.vgInit = "1";

  const dataPath = menu.dataset.stream;
  loadGallery(0, dataPath);
};

document.addEventListener('DOMContentLoaded', initVideoGallery);

new MutationObserver(initVideoGallery)
  .observe(document.documentElement, { childList: true, subtree: true });